import React from 'react';
import ToggleOn from '@material-ui/icons/ToggleOn';
import ToggleOff from '@material-ui/icons/ToggleOff';
import './RuleToggle.scss';

function RuleToggle(props) {
    const isDisabled = props.fakeRule;

    if (props.toggleOn) {
        return (
            <ToggleOn
                className={`rule-toggle on ${isDisabled ? 'disabled' : ''}`}
                onClick={isDisabled ? undefined : () => props.disableRule(props.ruleId)}
                style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            />
        );
    } else {
        return (
            <ToggleOff
                className={`rule-toggle off ${isDisabled ? 'disabled' : ''}`}
                onClick={isDisabled ? undefined : () => props.enableRule(props.ruleId)}
                style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            />
        );
    }
}

export default RuleToggle;
